import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


import './common/css/global.css'
import './common/css/styles.css'
import './assets/panel-theme.css'
import * as echarts from 'echarts'
window.echarts = echarts
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations
      .filter(registration => new URL(registration.scope).pathname.startsWith('/guxian/'))
      .map(registration => registration.unregister()))
    if ('caches' in window) {
      const keys = await window.caches.keys()
      await Promise.all(keys
        .filter(key => /guxian|multimodal|workbox/i.test(key))
        .map(key => window.caches.delete(key)))
    }
  })
}

Vue.use(ElementUI)

new Vue({
  render: h => h(App),
}).$mount('#app')
